import { render, staticRenderFns } from "./PriTama03_Nico.vue?vue&type=template&id=165092e7&scoped=true&"
import script from "./PriTama03_Nico.vue?vue&type=script&lang=js&"
export * from "./PriTama03_Nico.vue?vue&type=script&lang=js&"
import style0 from "./PriTama03_Nico.vue?vue&type=style&index=0&id=165092e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165092e7",
  null
  
)

export default component.exports